<template>
  <div>    
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/automationer">Visa alla automationer</router-link>
        <router-link tag="li" to="/automationer/ny">Skapa ny automation</router-link>
      </ul>
      <div class="clear"></div>
    </div>
    
   <!-- <button @click="showModal('hello-world')">Lägg till trigger</button>-->

    <!--<modal name="hello-world" height="500" :scrollable="true" style="margin-top:20px;">-->
    <div v-if="!done">
    <h4><a href="#" @click="back" v-if="triggerId.length">Tillbaka</a> <span v-if="triggerId.length">&rarr;</span> Lägg till trigger</h4>
    <p v-if="!triggerId.length">Trigger (eller utlösare) är den händelsen som kör igång hela automationen, validerar villkoren och i slutändan kör alla kommandon.</p>
      <table v-if="!triggerId.length">
        <tbody>
          <tr v-for="trigger in triggers" @click="triggerId = trigger.id">
            <td>{{ trigger.label }}</td>
            <td align="right">&rarr;</td>
          </tr>
        </tbody>
      </table>
      
      <div v-if="triggerId.length && !showSelectOperator" style="margin-top:10px;">
        <trigger-time v-if="triggerId === 'time'" type="trigger" @options="tesa"></trigger-time>    
        <trigger-device v-if="triggerId === 'device'" type="trigger" @options="tesa"></trigger-device>
        <trigger-presence v-if="triggerId === 'presence'" type="trigger" @options="tesa"></trigger-presence>
      </div>
      
      <p>
        <button :disabled="Object.keys(selectedTrigger).length === 0" @click="continueToLastStep">Spara och fortsätt till nästa steg</button>
      </p>
      
      <table v-if="showSelectOperator">
        <tbody>
          <tr @click="setOperator('eq')"><td>är lika med ({{ selectedTrigger.value }})</td><td align="right">&rarr;</td></tr>
          <tr @click="setOperator('ne')"><td>är inte lika med ({{ selectedTrigger.value }})</td><td align="right">&rarr;</td></tr>
          <tr @click="setOperator('gt')"><td>är över ({{ selectedTrigger.value }})</td><td align="right">&rarr;</td></tr>
          <tr @click="setOperator('gte')"><td>är över eller exakt ({{ selectedTrigger.value }})</td><td align="right">&rarr;</td></tr>
          <tr @click="setOperator('lt')"><td>är under ({{ selectedTrigger.value }})</td><td align="right">&rarr;</td></tr>
          <tr @click="setOperator('lte')"><td>är under eller exakt ({{ selectedTrigger.value }})</td><td align="right">&rarr;</td></tr>
        </tbody>
      </table>
    </div>
      
      
      {{ selectedTrigger }}
   <!-- </modal>-->
  
    <!--
    <table v-if="doTrigger">
      <tbody>
        <tr v-for="option in doTrigger.options" @click="doTrigger = option">
          <td>{{ option.label }}</td>
          <td align="right">&rarr;</td>
        </tr>
      </tbody>
    </table>-->
      
            <!--
    <modal name="hello-world">
      <div style="padding:12px;">
        
        <table v-if="!doTrigger">
          <tbody>
            <tr v-for="trigger in triggers" @click="doTrigger = trigger">
              <td>{{ trigger.label }}</td>
              <td align="right">&rarr;</td>
            </tr>
          </tbody>
        </table>

        <table v-if="doTrigger">
          <tbody>
            <tr v-for="option in doTrigger.options" @click="doTrigger = option">
              <td>{{ option.label }}</td>
              <td align="right">&rarr;</td>
            </tr>
          </tbody>
        </table>
      </div>
    </modal>
    -->
    
  </div>
</template>

<script>
  import { eventbus } from '../eventbus.js'
  import { HTTP } from '../http.js'
  import commandsView from './views/commandsView'
  import TriggerTime from './automationer/trigger_time'
  import TriggerDevice from './automationer/trigger_device'
  import TriggerPresence from './automationer/trigger_presence'

  export default {
    name: 'automationer',
    components: {
      commandsView,
      TriggerTime,
      TriggerDevice,
      TriggerPresence
    },
    data () {
      return {
        currentOpenModal: null,
        test: {},
        triggerType: '',
        meta: null,
        doTrigger: null,
        doz: null,
        triggerId: '',
        selectedTrigger: {},
        showSelectOperator: false,
        done: false
      }
    },
    created () {
    },
    methods: {
      back () {
        this.triggerId = ''       
      },
      
      continueToLastStep () {
        if (this.triggerType === 'number') {
          //this.showSelectOperator = true
          this.done = true
        }
      },
      
      tesa (opts) {
        this.selectedTrigger = opts.trigger
        this.triggerType = opts.type
      },
      
      setOperator (operator) {
        this.selectedTrigger.operator = operator
      },
      
      showModal (name, meta = null) {
        if (this.currentOpenModal) {
          this.$modal.hide(this.currentOpenModal)
        }
        
        if (meta) {
          this.meta = meta
        }

        this.$modal.show(name)
        this.currentOpenModal = name
      },
      
      showInput (systemType, subtype, triggerType) {
        this.test = {
          systemType,
          subtype,
          operator: 'eq',
          value: ''
        }
        
        this.triggerType = triggerType
        
        this.showModal('setValue')
      },
      
      triggerCapabilities (capabilities) {
        let bajs = []

        capabilities.forEach(capability => {
          if (capability in this.capabilities) {
            this.capabilities[capability].triggers.forEach(trigger => {
              bajs.push(trigger)
            })
          }
        })
                      
        return bajs
      }
    },
    computed: {
      capabilities () {
        return {
          switchBinary: {
            name: {
              sv: 'Mottagare på/av'
            },
            type: 'boolean',
            set: true,
            get: true,
            triggers: [
              { name: 'tänds', value: true },
              { name: 'släcks', value: false }
            ]
          },
          switchLevel: {
            name: {
              sv: 'Mottagare – dimmer'
            },
            type: 'number',
            set: true,
            get: true,
            triggers: [
              { name: 'dimras' }
            ]
          }
        }
      },

      triggers () {
        return [
          {
            id: 'time',
            label: 'Tid & solen',
            type: 'list',
            options: [
              {
                label: 'Klockan blir',
                type: 'clock'
              },
              {
                label: 'Minuten blir (59)',
                type: 'number',
                min: 0,
                max: 59
              }
            ]
          },
          {
            label: 'Automationer',
            type: 'list',
            options: this.$root.data.triggers.map(t => {
              return {
                label: t.name,
                type: 'list',
                options: [
                  { label: 'Startades' },
                  { label: 'Är klar' }
                ]
              }
            })
          },
          {
            label: 'Systemet',
            type: 'list',
            options: [
              {
                label: 'Bridgen har startat'
              }
            ]
          },
          {
            id: 'presence',
            label: 'Närvaro',
            type: 'list',
            options: [
              {
                label: 'Någon är närvarande'
              },
              {
                label: 'Ingen är nävarande'
              }
            ]
          },
          {
            id: 'device',
            label: 'Enheter',
            type: 'list',
            options: this.$root.data.nodes.filter(n => !n.hideInApp).map(node => {
              return {
                label: node.name,
                type: 'list',
                options: this.triggerCapabilities(node.capabilities).map(cap => {
                  return {
                    label: cap.name
                  }
                })
              }
            })
          }
        ]
      }
    },
    destroyed () {}
  }
</script>

<style scoped>
  .item {
    padding-bottom:10px;
  }
  
  h4 {
    margin-bottom:0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/dev_automationer_ny.vue